import { ProcessesSortByDto, ProcessStatusDto } from '@/api/generated';
import { candidateExternalProcessStatusTranslation } from '@/assets/locales/views/processes/details/list/processCandidatesList.translation.pl.ts';
import {
  ProcessListTranslation,
  ProcessStatusesTranslation,
} from '@/assets/locales/views/processes/list/processList.translation.en.ts';
import { quickTipsTranslation } from '@/assets/locales/views/processes/list/quickTips/quickTips.translation.pl.ts';

const statusesTranslation: ProcessStatusesTranslation = {
  [ProcessStatusDto.Active]: 'Aktywny',
  [ProcessStatusDto.Archived]: 'Zarchiwizowany',
  [ProcessStatusDto.AwaitingConfiguration]: 'Oczekuje na konfigurację',
  [ProcessStatusDto.Closed]: 'Zamknięty',
  [ProcessStatusDto.Error]: 'Błąd',
  [ProcessStatusDto.ErrorPendingRestart]: 'Oczekuje na restart',
  [ProcessStatusDto.InCreation]: 'W trakcie tworzenia',
  [ProcessStatusDto.InProgress]: 'W toku',
};

export const processListTranslation: ProcessListTranslation = {
  body: {
    actions: 'Akcje',
    awaitingProcessingCount: 'Oczekujących',
    [ProcessesSortByDto.CreatedBy]: 'Utworzony przez',
    [ProcessesSortByDto.Date]: 'Data',
    [ProcessesSortByDto.ExternalProcessId]: 'eRecruiter ID',
    [ProcessesSortByDto.Name]: 'Nazwa',
    [ProcessesSortByDto.OrdinalNumber]: 'ID',
    [ProcessesSortByDto.Requirements]: 'Wymagania',
    [ProcessesSortByDto.Status]: 'Status',
  },
  dialog: {
    confirmationRetryProcessContent:
      'Czy na pewno chcesz zrestartować ten proces? Operacja ponowi jego przetwarzanie.',
  },
  externalProcessStatuses: candidateExternalProcessStatusTranslation,
  head: {
    createdBy: 'Utworzony przez',
    dateFrom: 'Data od',
    dateTo: 'Data do',
    externalProcessId: 'eRecruiter ID',
    ordinalNumber: 'ID',
    searchPhrase: 'Szukaj po nazwie lub wymaganiach',
    statuses: 'Status',
  },
  labels: {
    activate: 'Aktywuj',
    close: 'Ukryj',
    closedProjects: 'Zamknięte procesy',
    eRecruiter: 'eRecruiter',
    noAwaitingConfigurationProcesses: 'Brak procesów oczekujących na konfigurację',
    noClosedProjects: 'Brak zamkniętych procesów',
    retryProcess: 'Restartuj',
    runProcess: 'Uruchom',
    startAnalysis: 'Rozpocznij analizę',
    startProcess: 'Rozpocznij proces',
    unassigned: 'Brak właściciela',
    view: 'Zobacz',
  },
  notLinked: 'niepołączony z eRecruiter',
  possibleStatuses: {
    statuses: {
      [ProcessStatusDto.Active]: 'Aktywuj',
      [ProcessStatusDto.Archived]: 'Zarchiwizuj',
      [ProcessStatusDto.Closed]: 'Zamknij',
    },
    title: 'Zmień status',
    unhide: 'Odkryj',
  },
  quickTips: quickTipsTranslation,
  statuses: statusesTranslation,
  tour: {
    awaitingConfigurationProcessesButton: {
      text: 'Aby rozpocząć nowy proces, kliknij ten przycisk. Wyświetlisz listę procesów wstępnie pobranych z eRecruitera. Odszukaj właściwy proces, korzystając z filtra "eRecruiter ID", i otwórz jego szczegóły. Następnie wybierz "Rozpocznij analizę".',
      title: 'Rozpocznij nowy proces',
    },
    closedProcessesButton: {
      text: 'Teraz możesz zamykać procesy. Zamknięte procesy nie są domyślnie wyświetlane na liście. Ten przycisk pokazuje, ile masz zamkniętych procesów. Kliknij go, aby wyświetlić swoje zamknięte procesy.',
      title: 'Zamknięte procesy',
    },
    createdByFilter: {
      text: 'Tego filtra używaj, aby pokazać procesy wybranego użytkownika. Wyczyść go, aby zobaczyć wszystkie procesy, także importowane oczekujące na konfigurację.',
      title: 'Filtr utworzony przez',
    },
    statusesFilter: {
      text: 'Teraz domyślnie widzisz tylko aktywne procesy. Aby zobaczyć wszystkie wystarczy wyczyścić ten filtr.',
      title: 'Filtr statusów',
    },
    toggleVisibilityButton: {
      text: 'Proces można szybko zamknąć lub ponownie otworzyć tym przyciskiem w wierszu, bez przechodzenia do szczegółów procesu.',
      title: 'Szybkie zamykanie procesu',
    },
  },
};
